

export const ROUTES = {
  LOGIN: "/login",
  LANDING: "/",
   BLOG: "/blog",
    BLOG_DETAIL: "/blog/:slug",
  PRIVACY_POLICY: "/privacy-policy",
  REFUND_POLICY: "/refund-policy",
  TERMS: "/terms",
  APPLY: "/apply/:token",
  APPLY_QR: "/apply/:token/qr",
  VERIFY_STUDENT: "/verify/:institutionCode/:studentCode",
  VERIFY_STUDENT_TOKEN: "/verify/:token",
  VISIT_PREREG: "/visit/:token",
  VISIT_QR: "/visit/:token/qr",
  RECEIPT_PUBLIC: "/receipt/:token",
  CERTIFICATE_PUBLIC: "/certificate/:token",

SUPER_ADMIN: {
  DASHBOARD: "/super-admin/dashboard",
  LEAD_TRACKER: "/super-admin/lead-tracker",
  ORG_MANAGEMENT: "/super-admin/org-management",
  SUBSCRIPTION_HISTORY: "/super-admin/subscription-history",
  ORG_MANAGEMENT_DETAILS: "/super-admin/org-management/:organizationId",
  ORG_RECYCLE_BIN: "/super-admin/org-management/:organizationId/recycle-bin",
  INSTITUTION_RECYCLE_BIN: "/super-admin/org-management/recycle-bin",
  // Campus details sits under the organization's details route —
  // reached from CampusTable's "View Details" button.
  CAMPUS_DETAILS: "/super-admin/org-management/:organizationId/campus/:campusId",
  INDEPENDENT_INSTITUTION_DETAILS: "/super-admin/org-management/independent/:institutionId",
  ORGANIZATIONS: "/super-admin/organizations",
  CAMPUSES: "/super-admin/campuses",
  INSTITUTIONS: "/super-admin/institutions",
  INTERNAL_ROLES: "/super-admin/internal-roles",
  STAFF: "/super-admin/staff",
  SUBJECTS: "/super-admin/subjects",
  FEE_CATEGORIES: "/super-admin/fee-categories",
  FEE_TEMPLATES: "/super-admin/fee-templates",
  WHATSAPP: "/super-admin/whatsapp",
  ACADEMIC_SETUP: "/super-admin/academic-setup",
  AUDIT_LOGS: "/super-admin/audit-logs",
  LOGIN_ACTIVITY: "/super-admin/login-activity",
  ERROR_LOGS: "/super-admin/error-logs",
  STORAGE: "/super-admin/storage",
  STORAGE_DETAILS: "/super-admin/storage/:scope/:id",
  ACADEMIC_YEARS: "/super-admin/academic-years",
  STUDENT_CATEGORIES: "/super-admin/student-categories",
  RELIGIONS: "/super-admin/religions",
  SIGNATURE_ROLES: "/super-admin/signature-roles",
  REPORT_TEMPLATES: "/super-admin/report-templates",
  ADMISSION_FORMS: "/super-admin/admission-forms",
  CMS: {
    HERO: "/super-admin/cms/hero",
    CHALLENGES: "/super-admin/cms/challenges",
    PRICING: "/super-admin/cms/pricing",
    TESTIMONIALS: "/super-admin/cms/testimonials",
    FAQ: "/super-admin/cms/faq",
    SOCIAL_LINKS: "/super-admin/cms/social-links",
    BLOG: "/super-admin/cms/blog",
    PAGES: "/super-admin/cms/pages",
  },
},

ORG_ADMIN: {
  DASHBOARD: "/org-admin/dashboard",
  SETTINGS: "/org-admin/settings",
  BILLING: "/org-admin/billing",
  SHARED_STAFF: "/org-admin/shared-staff",
  DRIVERS: "/org-admin/drivers",
  ACCOUNTANTS: "/org-admin/accountants",
  LIBRARIANS: "/org-admin/librarians",
},

  CAMPUS_ADMIN: {
    DASHBOARD: "/campus-admin/dashboard",
    INSTITUTIONS: "/campus-admin/institutions",
    STUDENTS: "/campus-admin/students",
    ATTENDANCE: "/campus-admin/attendance",
    STAFF: "/campus-admin/staff",
    DRIVERS: "/campus-admin/drivers",
    ACCOUNTANTS: "/campus-admin/accountants",
    LIBRARIANS: "/campus-admin/librarians",
    FEES: "/campus-admin/fees",
    REPORTS: "/campus-admin/reports",
  },

  INSTITUTION_ADMIN: {
    DASHBOARD: "/institution-admin/dashboard",
    ADMISSIONS: "/institution-admin/admissions",
    PROMOTIONS: "/institution-admin/promotions",
    STUDENTS: "/institution-admin/students",
    STUDENT_MANAGEMENT: "/institution-admin/student-management",
    STAFF_HR: "/institution-admin/staff-hr",
    STAFF_ID_CARDS: "/institution-admin/staff-id-cards",
    TEACHING_LEARNING: "/institution-admin/teaching-learning",
    COMMUNICATION: "/institution-admin/communication",
    ID_CARDS: "/institution-admin/id-cards",
    ATTENDANCE: "/institution-admin/attendance",
    STAFF_ATTENDANCE: "/institution-admin/staff-attendance",
    LEAVE: "/institution-admin/leave",
    STAFF_MEETINGS: "/institution-admin/staff-meetings",
    STUDENT_LEAVE: "/institution-admin/student-leave",
    STUDENT_JOURNEY: "/institution-admin/student-journey",
    CLASS_DIARY: "/institution-admin/class-diary",
    LESSON_PLANS: "/institution-admin/lesson-plans",
    ACADEMICS: "/institution-admin/academics",
    EXAMS_RESULTS: "/institution-admin/exams-results",
    HOMEWORK: "/institution-admin/homework",
    NOTES: "/institution-admin/notes",
    SYLLABUS: "/institution-admin/syllabus",
    NOTICES: "/institution-admin/notices",
    CERTIFICATES: "/institution-admin/certificates",
    FEES_PAYMENTS: "/institution-admin/fees-payments",
    OLD_DUES: "/institution-admin/old-dues",
    STAFF_PAYROLL: "/institution-admin/staff-payroll",
    ALL_STAFF: "/institution-admin/staff",
    PAYROLL: "/institution-admin/payroll",
    FACILITIES: "/institution-admin/facilities",
    LIBRARY: "/institution-admin/library",
    TRANSPORT: "/institution-admin/transport",
    HOSTEL: "/institution-admin/hostel",
    VISITORS: "/institution-admin/visitors",
    STORE: "/institution-admin/store",
    INVENTORY: "/institution-admin/inventory",
    FINANCE_ACCOUNTING: "/institution-admin/finance-accounting",
    ONLINE_LEARNING: "/institution-admin/online-learning",
    ALUMNI: "/institution-admin/alumni",
    ACADEMIC_PROGRAMS: "/institution-admin/academic-programs",
    BATCH_COURSE_MANAGEMENT: "/institution-admin/batch-course-management",
    STREAMS: "/institution-admin/streams",
    TEACHERS: "/institution-admin/teachers",
    DRIVERS: "/institution-admin/drivers",
    ACCOUNTANTS: "/institution-admin/accountants",
    LIBRARIANS: "/institution-admin/librarians",
    FRONT_DESK: "/institution-admin/front-desk",
    ROLES_PERMISSIONS: "/institution-admin/roles-permissions",
    BILLING: "/institution-admin/billing",
    SETTINGS: "/institution-admin/settings",
  },

  TEACHER_PORTAL: {
    DASHBOARD: "/teacher/dashboard",
    TIMETABLE: "/teacher/timetable",
    ATTENDANCE: "/teacher/attendance",
    MARKS: "/teacher/marks",
    HOMEWORK: "/teacher/homework",
    NOTES: "/teacher/notes",
    ONLINE_CLASSES: "/teacher/online-classes",
    STAFF_MEETINGS: "/teacher/staff-meetings",
    STUDENT_LEAVE: "/teacher/student-leave",
    CLASS_DIARY: "/teacher/class-diary",
    STUDENT_JOURNEY: "/teacher/student-journey",
    LESSON_PLANS: "/teacher/lesson-plans",
    SYLLABUS: "/teacher/syllabus",
    HOSTEL: "/teacher/hostel",
    PROFILE: "/teacher/profile",
  },

  STUDENT_PORTAL: {
    DASHBOARD: "/student/dashboard",
    TIMETABLE: "/student/timetable",
    ATTENDANCE: "/student/attendance",
    FEES: "/student/fees",
    EXAMS: "/student/exams",
    RESULTS: "/student/results",
    // EXAMS: "/student/exams",
    HOMEWORK: "/student/homework",
    NOTES: "/student/notes",
    ONLINE_CLASSES: "/student/online-classes",
    LEAVE: "/student/leave",
    DIARY: "/student/diary",
    SYLLABUS: "/student/syllabus",
    PROFILE: "/student/profile",
  },

  STAFF_PORTAL: {
    DASHBOARD: "/staff/dashboard",
  },

  STUDENT_PARENT: {
    DASHBOARD: "/student-parent/dashboard",
    ACADEMICS: "/student-parent/academics",
    ATTENDANCE: "/student-parent/attendance",
    FEES: "/student-parent/fees",
    COMMUNICATION: "/student-parent/communication",
    PROFILE: "/student-parent/profile",
  },
} as const;
